let userSessionGeneration = 0;

export const getUserSessionGeneration = () => userSessionGeneration;

export const advanceUserSessionGeneration = () => {
  userSessionGeneration += 1;
  return userSessionGeneration;
};
